import api from '../services/api'

export const MON_TG_INCOMING_CURSORS_KEY = 'mon_tg_incoming_cursors_v1'

export type MonIncomingBumpItem = {
  chat_id?: string
  /** Подпись чата из monitoring_state (не числовой id). */
  chat_title?: string | null
  message_id?: number
  topic_top_message_id?: number | null
  text?: string
  date?: string | null
  sender_name?: string | null
  linked_client_id?: string | null
  team_hub_channel_id?: string | null
}

type Subscriber = (items: MonIncomingBumpItem[]) => void

const subscribers = new Set<Subscriber>()

function loadCursorsFromStorage(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(MON_TG_INCOMING_CURSORS_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as Record<string, unknown>
    if (!parsed || typeof parsed !== 'object') return {}
    const next: Record<string, number> = {}
    for (const [k, v] of Object.entries(parsed)) {
      const ks = String(k).trim()
      if (!ks) continue
      const n = typeof v === 'number' ? v : parseInt(String(v), 10)
      if (Number.isFinite(n)) next[ks] = n
    }
    return next
  } catch {
    return {}
  }
}

let mergedCursors: Record<string, number> = loadCursorsFromStorage()

function persistCursors() {
  try {
    sessionStorage.setItem(MON_TG_INCOMING_CURSORS_KEY, JSON.stringify(mergedCursors))
  } catch {
    /* private mode */
  }
}

let intervalId: ReturnType<typeof setInterval> | undefined
let pollInFlight = false

async function pollOnce() {
  // Несколько открытых вкладок не должны одновременно нагружать общий API.
  // При возврате на вкладку страница вызывает flushMonitoringIncomingBumpPoll().
  if (subscribers.size === 0 || document.visibilityState !== 'visible' || pollInFlight) return
  pollInFlight = true
  try {
    const { data } = await api.post('/api/telethon-monitoring/recent-incoming-bump', {
      cursors: mergedCursors,
    })
    const o = data as {
      items?: MonIncomingBumpItem[]
      cursors?: Record<string, number | string>
    }
    if (o.cursors && typeof o.cursors === 'object') {
      const nxt: Record<string, number> = {}
      for (const [k, v] of Object.entries(o.cursors)) {
        const ks = String(k).trim()
        if (!ks) continue
        const num = typeof v === 'number' ? v : parseInt(String(v), 10)
        if (Number.isFinite(num)) nxt[ks] = num
      }
      mergedCursors = { ...mergedCursors, ...nxt }
      persistCursors()
    }
    const items = Array.isArray(o.items) ? o.items : []
    if (items.length === 0) return
    for (const cb of subscribers) {
      cb(items)
    }
  } catch {
    /* PG может быть выключен */
  } finally {
    pollInFlight = false
  }
}

function ensurePolling() {
  if (intervalId != null) return
  // 20 секунд достаточно для тостов, а защита от overlap сохраняет очередь API свободной.
  intervalId = window.setInterval(() => void pollOnce(), 20_000)
  void pollOnce()
}

/** Сразу опросить PG (возврат на вкладку, без ожидания таймера). */
export function flushMonitoringIncomingBumpPoll(): void {
  void pollOnce()
}

function stopPollingIfIdle() {
  if (subscribers.size > 0) return
  if (intervalId != null) {
    window.clearInterval(intervalId)
    intervalId = undefined
  }
}

/** Один интервал на всех подписчиков (страница мониторинга + портал). */
export function subscribeMonitoringIncomingBump(handler: Subscriber): () => void {
  subscribers.add(handler)
  ensurePolling()
  return () => {
    subscribers.delete(handler)
    stopPollingIfIdle()
  }
}
